
(function() {
  var result = { translations: { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.1068"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1068",
    "ar-eg": "static-7.1068",
    "bg": "static-7.1068",
    "bn": "static-7.1068",
    "ca-es": "static-7.1068",
    "cs": "static-7.1068",
    "da": "static-7.1068",
    "de": "static-7.1068",
    "el": "static-7.1068",
    "en-gb": "static-7.1068",
    "en": "static-7.1068",
    "es-mx": "static-7.1068",
    "es": "static-7.1068",
    "et": "static-7.1068",
    "fi": "static-7.1068",
    "fr-ca": "static-7.1068",
    "fr": "static-7.1068",
    "he-il": "static-7.1068",
    "hi": "static-7.1068",
    "hr": "static-7.1068",
    "hu": "static-7.1068",
    "id": "static-7.1068",
    "it": "static-7.1068",
    "ja": "static-7.1068",
    "ko": "static-7.1068",
    "lt": "static-7.1068",
    "ms": "static-7.1068",
    "nl": "static-7.1068",
    "no": "static-7.1068",
    "pl": "static-7.1068",
    "pt-br": "static-7.1068",
    "pt-pt": "static-7.1068",
    "ro": "static-7.1068",
    "ru": "static-7.1068",
    "sk": "static-7.1068",
    "sl": "static-7.1068",
    "sv": "static-7.1068",
    "th": "static-7.1068",
    "tl": "static-7.1068",
    "tr": "static-7.1068",
    "uk": "static-7.1068",
    "vi": "static-7.1068",
    "x-pseudo": "static-7.1068",
    "zh-cn": "static-7.1068",
    "zh-hk": "static-7.1068",
    "zh-tw": "static-7.1068"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.1068'}); }
})();


